import { z } from 'zod';
import React from 'react';

// シーク機能のコールバック関数の型
export type SeekToTimeFunction = (seconds: number) => void;

// レンダリング結果の型定義
export type CommentContentElements = React.ReactNode[];

// Zodスキーマ定義
export const CommentContentInputSchema = z.object({
  text: z.string(),
  onSeekToTime: z.function()
    .args(z.number())
    .returns(z.void())
    .optional(),
});

export type CommentContentInput = z.infer<typeof CommentContentInputSchema>; 